import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeLocationAction } from '../../reducers/actions';
import { LocationService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_LOCATION),
    switchMap(action =>
      LocationService.delete(action.location, store).pipe(
        map(() => removeLocationAction(action.location)),
        catchError(retryAuthentication(action$, 'epics/locations/deleteLocation'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/locations/deleteLocation.js